import React from "react";
import Studenthome from "./Studenthome";
import "./Dashboard.css"; // New separate CSS file

const Dashboard = () => {
  return (
    <div className="dashboard-page">
      <Studenthome />
    </div>
  );
};

export default Dashboard; 